import { TableCell, TableHead, TableRow } from "@mui/material";
import React from "react";

const headerCellStyle = {
  fontSize: "13px",
  // fontWeight: 600,
  borderLeft: "1px solid #ddd",
  whiteSpace: "nowrap",
  py: 1,
  // textAlign: "center",
  backgroundColor: "#ececec",
};

const headerRowStyle = {
  backgroundColor: "rgba(64, 64, 64, 0.1)",
};

function TableHeader2({ tableData, page }) {
  return (
    <>
      <TableHead>
        <TableRow sx={headerRowStyle}>
          {tableData.columns.map((column, index) => (
            <TableCell key={index} sx={headerCellStyle}>
              {column}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    </>
  );
}

export default TableHeader2;
